

















































































































import {Prop} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import storeDevisElementsList from '@/stores/modules/devisElementsList';
import storeDevis from "@/stores/modules/devis";

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import Checked from '@/components/Checked.vue';
import TableCell from '@/components/Paginate/TableCell.vue';
import {
	DxColumn,
	DxDataGrid,
	DxEditing,
	DxFilterRow,
	DxGrouping,
	DxGroupItem,
	DxGroupPanel,
	DxHeaderFilter,
	DxLookup,
	DxMasterDetail, DxPager, DxPaging,
	DxRangeRule,
	DxRequiredRule,
	DxScrolling,
	DxStringLengthRule,
	DxSummary,
	DxTotalItem, DxValueFormat
} from "devextreme-vue/data-grid";
import {DxCheckBox} from "devextreme-vue/check-box";
import {DevisElementsList, Token} from "@/models";
import {createStore} from "devextreme-aspnet-data-nojquery";
import {Stored} from "vue-stored-prop-decorator";
import storeToken from "@/stores/modules/token";
import CrudDeleteDialog from "@/components/Crud/DeleteDialog.vue";
import CrudDevisElementsListEditDialog from "@/components/Crud/DevisElementsList/EditDialog.vue";

@Component({
	components: {
		CrudList, TableHead, TableCell,
		DxDataGrid, DxColumn, DxEditing,
		DxFilterRow, DxHeaderFilter, DxGroupPanel,
		DxGrouping, DxScrolling, DxSummary,
		DxLookup, DxTotalItem, DxGroupItem,
		DxMasterDetail, DxStringLengthRule, DxRangeRule,
		DxRequiredRule, DxValueFormat, DxPaging,
		DxPager, DxCheckBox, Checked,
		CrudDeleteDialog,
		CrudDevisElementsListEditDialog,
	}
})
export default class CrudDevisElementsListList extends Vue {

	@Prop({type: Boolean, default: true  }) private paginate;
	@Prop({type: Boolean, default: false }) private dense;
	@Stored(() => storeToken) token!: Token;
	private editElement: DevisElementsList = null;

	private storeDevisElementsList = storeDevisElementsList;

	private url = process.env.VUE_APP_BACK_BASE_URL + '/api/devis/elements'

	private editDevisElementsList: DevisElementsList = null;
	private deletedDevisElementsList: DevisElementsList = null;
	private dataGrid;

	private dataSource = createStore({
		key: 'id',
		loadUrl: `${this.url}/dxDataGrid/${this.$route.params.id}`,
		onBeforeSend: (method, ajaxOptions) => {
			ajaxOptions.xhrFields = { withCredentials: true };
			ajaxOptions.headers = {
				'Authorization': 'BEARER ' + this.token.id
			}
		},
	});

	public refresh() {
		this.dataGrid = this.$refs['dataGridRefKey'] as DxDataGrid
		this.dataGrid.instance.refresh()
		storeDevis.dispatch('get', this.$route.params.id)
		this.$forceUpdate();
	}

	private calculateCellValue(data) {
		let date = data.date
		if (date === null) { return }
		let year = date.substr(0,4)
		let month = date.substr(5,2)
		let day = date.substr(8,2)
		return day + '/' + month + '/' + year
	}

	private calculateAmount(data) {
		return parseFloat(data.amount).toFixed(2) + ' €'
	}

	private calculatePurchase(data) {
		return parseFloat(data.purchase_price).toFixed(2) + ' €'
	}

	private calculateTotal(data) {
		let value = ((data.amount * data.quantity) - ((data.amount * data.quantity) * (data.discount / 100))).toFixed(2)
		return value + ' €'
	}
}
